'use strict';

module.exports = require( './lib' ).PhoneNumber;

Object.defineProperty(
	module.exports,
	"__esModule",
	{
		value: true
	}
);

module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/awesome-phonenumber/index.js
// module id = 1088
// module chunks = 0